import { render, staticRenderFns } from "./PhoneTypologyTable.vue?vue&type=template&id=b0cf773c&"
import script from "./PhoneTypologyTable.vue?vue&type=script&lang=js&"
export * from "./PhoneTypologyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports